// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `footer>div{
    margin: 0 10%;
    color: #fff;
}
footer li a{
    margin-left: 30px;
    text-decoration: none;
    color: #fff;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImZvb3Rlci5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0lBQ0ksYUFBYTtJQUNiLFdBQVc7QUFDZjtBQUNBO0lBQ0ksaUJBQWlCO0lBQ2pCLHFCQUFxQjtJQUNyQixXQUFXO0FBQ2YiLCJmaWxlIjoiZm9vdGVyLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyJmb290ZXI+ZGl2e1xuICAgIG1hcmdpbjogMCAxMCU7XG4gICAgY29sb3I6ICNmZmY7XG59XG5mb290ZXIgbGkgYXtcbiAgICBtYXJnaW4tbGVmdDogMzBweDtcbiAgICB0ZXh0LWRlY29yYXRpb246IG5vbmU7XG4gICAgY29sb3I6ICNmZmY7XG59Il19 */`, "",{"version":3,"sources":["webpack://./src/app/footer/footer.component.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW;AACf;AACA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,WAAW;AACf;AACA,wfAAwf","sourcesContent":["footer>div{\n    margin: 0 10%;\n    color: #fff;\n}\nfooter li a{\n    margin-left: 30px;\n    text-decoration: none;\n    color: #fff;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
